<script>
export default {
    name: "DialogRentIncreaseSettings",
    data() {
        return {
            visible: false,
            settings: {
                increase_rate: 0,
                generate_date: '',
                effective_date: '',
                agent_id: '1000062',
                sign_date: ''
            },
            callback: null
        }
    },
    methods: {
        open(callback) {
            this.visible = true;
            this.callback = callback;
        },
        close() {
            this.visible = false;
        },
        submit() {
            this.close();
            if (this.callback) this.callback(this.settings);
        }
    },
    mounted() {
    }
}
</script>

<template>
    <el-dialog
        title="Rent Increase Settings"
        closeable
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        @close="close"
    >
        <el-form size="medium" label-width="220px" style="width: 600px;">
            <el-form-item label="Rent increase Percentage">
                <el-input v-model="settings.increase_rate">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Generate Report Date">
                <el-date-picker
                    v-model="settings.generate_date"
                    type="date"
                    placeholder="Select date"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    style="width: 100%;"
                />
            </el-form-item>
            <el-form-item label="Rent Increase Effective Date">
                <el-date-picker
                    v-model="settings.effective_date"
                    type="date"
                    placeholder="Select date"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    style="width: 100%;"
                />
            </el-form-item>
            <el-form-item label="Agent ID">
                <el-input v-model="settings.agent_id"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">Submit</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<style scoped>

</style>